/**
 * 发布套餐相关接口写这
 */
import { API_EDIT } from '@constant'
import http, { createApi } from '@core/fetch'

export default {
  //createApi('/p/wedding/Home/APIMerchant/decoration')
  //createApi.post('/p/wedding/Home/APIMerchant/decoration')

  // 获取标签数据
  getTags: createApi('/p/wedding/index.php/admin/APISetMeal/mealMarks'),

  // 获取二级分类
  getSecondCategory: createApi(
    '/hps/admin/localServerMerchant/work/secondCategory'
  ),

  // 套餐订单礼全款礼历史数据
  orderAndPayAllGiftHistory: createApi(
    '/hps/admin/localServerMerchant/work/orderAndPayAllGiftHistory'
  ),

  // 编辑套餐
  editMeal: createApi.post('/p/wedding/index.php/admin/APISetMeal/edit'),

  // 新增套餐
  addMeal: createApi.post('/p/wedding/index.php/Admin/APICustomSetMeal/add'),

  // 新增/编辑套餐草稿
  savePackageDraft: createApi.post('/hms/merchant/appApi/draftWork/edit'),

  // 新增/编辑单品草稿
  saveSingleDraft: createApi.post('/hms/merchant/appApi/draftSku/edit'),

  // 删除套餐草稿
  deletePackageDraft: createApi.post('/hms/merchant/appApi/draftWork/delete'),

  // 删除单品草稿
  deleteSingleDraft: createApi.post('/hms/merchant/appApi/draftSku/delete'),

  // 删除套餐/单品
  deletePackage: body =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/delete', {
      body,
      onError: false
    }),
  //详情接口
  getDetail: body =>
    http('/p/wedding/index.php/admin/APISetMeal/info', { body }),

  // 单品草稿详情接口
  getSingleDraftDetail: createApi('/hms/merchant/appApi/draftSku/detail'),

  // 套餐草稿详情接口
  getPackageDraftDetail: createApi('/hms/merchant/appApi/draftWork/detail'),

  //获取初始信息
  getInitData: createApi('/p/wedding/index.php/Admin/APISetMealInfo'),
  // 获取第二步服务内容参数
  getServiceParam: createApi('/p/wedding/index.php/Admin/APISetMealInfo', {
    ignore: [null, undefined]
  }),

  // 获取服务内容配置
  getSetmealServiceConfig: createApi(
    '/p/wedding/index.php/admin/APISetMeal/set_meal_config'
  ),

  // 获取套餐信息
  getServiceData: createApi(API_EDIT, {
    ignore: [null, undefined]
  }),
  // 获取套餐的关联信息
  getSetmealRelation: createApi(
    '/p/wedding/index.php/Admin/APISetMealRelation/relative_examples'
  ),
  // 获取草稿套餐的关联信息
  getDraftSetmealRelation: createApi(
    '/p/wedding/Admin/APISetMealRelation/relativeExamplesByIds'
  ),
  // 提交
  addSetMeal: body =>
    http.post(
      `/p/wedding/index.php/admin/APISetMeal/add${
        body.imgUrlParam ? body.imgUrlParam : ' '
      }`,
      {
        body,
        ignore: [undefined]
      }
    ),
  editSetMeal: body =>
    http.post(
      `/p/wedding/index.php/admin/APISetMeal/edit${
        body.imgUrlParam ? body.imgUrlParam : ' '
      }`,
      {
        body,
        ignore: [undefined]
      }
    ),

  // 关闭提示
  closeIntroduction: () =>
    http.post('/p/wedding/index.php/Admin/APIMerchant/ClosePackageGuide'),
  //获取商家简称、商家名分词信息
  getMerchantAbbreviation: () =>
    http('/p/wedding/Admin/APIMerchant/merchantAbbreviation'),
  //获取推荐的搜索信息
  getMarketingInfoRecommend: body =>
    http('/p/wedding/Admin/APISetMeal/MarketingInfoRecommend', { body }),
  // 获取系列信息
  getSeriesList: body =>
    http('/p/wedding/index.php/Admin/APISeries/ListForSetMeal', { body }),

  getVipTagList: () =>
    http('/p/wedding/index.php/admin/APISetMeal/vipTagList', { expect: [] }),
  getScenicSpotList: createApi(
    '/hms/hljLocalserviceProduct/adminApi/scenicSpot/getByCityCode'
  ),
  // 获取城市景点列表
  getScenicSpotWithCity: createApi(
    '/p/wedding/index.php/admin/APIScenicSpot/listWithCase',
    {
      expect: []
    }
  )
}
